var map = {
	"./coursegoods/coursegoods.router.js": "e03a",
	"./dynamic/dynamic.router.js": "8eea",
	"./entrance/entrance.router.js": "a5fe",
	"./error/error.router.js": "bbc8",
	"./evaluation/evaluation.router.js": "131e",
	"./exam/exam.router.js": "1acc",
	"./global/global.router.js": "0a65",
	"./institution/institution.router.js": "7487",
	"./job/job.router.js": "e9e7",
	"./learning/learning.router.js": "f835",
	"./live/live.router.js": "22d2",
	"./lowcodeForm/lowcodeForm.router.js": "0fff",
	"./offlineTraining/offlineTraining.router.js": "c3af",
	"./openPlatform/openPlatform.router.js": "0199",
	"./personal/personal.router.js": "b843",
	"./practice/practice.router.js": "4e87",
	"./reUser/usercenter.router.js": "91b4",
	"./salesSystem/salesSystem.router.js": "4947",
	"./shuidian/shuidian.router.js": "b234",
	"./toC/other.router.js": "2047",
	"./train/train.router.js": "13db",
	"./universal/universal.router.js": "c9b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f700";